(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slg-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepareManifesto = (section) => {
      if (section.dataset.animation !== 'true' || section.dataset.manifestoReady === 'true') return;
      section.dataset.manifestoReady = 'true';
      section.classList.add('is-pending');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.24 });
      observer.observe(section);
    };

    const prepareAll = (scope = document) => scope.querySelectorAll('[data-manifesto]').forEach(prepareManifesto);
    prepareAll();
    document.addEventListener('shopify:section:load', (event) => prepareAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slg-impact-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (gallery) => {
      if (gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';
      const collectionTitle = document.querySelector('.slg-collection-intro__collection-title');
      if (collectionTitle) {
        const introSection = collectionTitle.closest('.shopify-section');
        collectionTitle.classList.add('slg-impact__collection-title');
        gallery.after(collectionTitle);
        if (introSection) introSection.hidden = true;
      }
      const slides = [...gallery.querySelectorAll('[data-slg-impact-slide]')];
      if (!slides.length) return;
      const count = gallery.querySelector('[data-slg-impact-count]');
      const progress = gallery.querySelector('[data-slg-impact-progress]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let paused = false;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; slide.classList.toggle('is-active', slideIndex === index); });
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        restart();
      };
      const stop = () => { clearTimeout(timer); gallery.dataset.running = 'false'; };
      const restart = () => {
        stop();
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = '';
        if (paused || reducedMotion.matches || document.hidden) return;
        gallery.dataset.running = 'true';
        timer = window.setTimeout(() => show(index + 1), 5000);
      };
      const toggle = gallery.querySelector('[data-slg-impact-toggle]');
      toggle.addEventListener('click', () => {
        paused = !paused;
        toggle.textContent = paused ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        restart();
      });
      gallery.querySelector('[data-slg-impact-prev]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-slg-impact-next]').addEventListener('click', () => show(index + 1));
      document.addEventListener('visibilitychange', restart);
      reducedMotion.addEventListener('change', restart);
      restart();
    };
    const initAll = () => document.querySelectorAll('[data-slg-impact]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slg-sale-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.dataset.saleReady) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const rows = Array.from(section.querySelectorAll('[data-sale-row]')).map((row) => {
        const viewport = row.querySelector('[data-sale-viewport]');
        viewport.scrollLeft = 0;
        const track = row.querySelector('.slg-sale-edit__track');
        const products = Array.from(track.querySelectorAll('[data-sale-price]'))
          .sort((a, b) => Number(a.dataset.salePrice) - Number(b.dataset.salePrice));
        products.forEach((product) => track.appendChild(product));
        const state = { row, viewport, track, products, width: 0, pitch: 0, position: 0, pausedUntil: 0, drag: null, pointerFocus: false, suppressClick: false };
        const wrap = (value) => state.width ? ((value % state.width) + state.width) % state.width : 0;
        const paint = () => {
          state.products.forEach((product, index) => {
            const x = wrap(index * state.pitch + state.position + state.pitch) - state.pitch;
            product.style.transform = `translate3d(${x}px, 0, 0)`;
          });
        };
        const measure = () => {
          const productWidth = state.products[0]?.getBoundingClientRect().width || 0;
          if (!productWidth) return;
          const gap = parseFloat(getComputedStyle(track).getPropertyValue('--sale-gap')) || 18;
          const pitch = productWidth + gap;
          if (pitch === state.pitch) return;
          state.pitch = pitch;
          state.width = pitch * state.products.length;
          state.position = 0;
          paint();
        };
        measure();
        state.observer = new ResizeObserver(measure);
        state.observer.observe(viewport);
        const pause = () => { state.pausedUntil = performance.now() + 4500; };
        viewport.addEventListener('pointerdown', (event) => {
          pause();
          state.pointerFocus = true;
          state.drag = { id: event.pointerId, x: event.clientX, position: state.position, moved: false };
        });
        viewport.addEventListener('pointermove', (event) => {
          if (!state.drag || event.pointerId !== state.drag.id) return;
          const distance = event.clientX - state.drag.x;
          if (!state.drag.moved && Math.abs(distance) < 6) return;
          if (!state.drag.moved) {
            state.drag.moved = true;
            viewport.setPointerCapture(event.pointerId);
          }
          state.position = wrap(state.drag.position + distance);
          paint();
          event.preventDefault();
        });
        const endDrag = (event) => {
          if (!state.drag || event.pointerId !== state.drag.id) return;
          state.suppressClick = event.type === 'pointerup' && state.drag.moved;
          state.drag = null;
          state.pointerFocus = false;
          pause();
        };
        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
        viewport.addEventListener('click', (event) => {
          if (!state.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          state.suppressClick = false;
        }, true);
        viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          state.position = wrap(state.position + (event.key === 'ArrowLeft' ? 176 : -176));
          paint();
          pause();
        });
        viewport.addEventListener('focusin', () => {
          if (!state.pointerFocus) {
            const focusedProduct = state.products.indexOf(document.activeElement);
            if (focusedProduct >= 0) state.position = wrap(-focusedProduct * state.pitch);
            paint();
          }
          state.pausedUntil = Infinity;
        });
        viewport.addEventListener('focusout', () => { state.pausedUntil = performance.now() + 2500; });
        return state;
      });
      section.dataset.saleReady = 'true';
      let lastTime = 0;
      const frame = (now) => {
        rows.forEach((state) => {
          if (state.viewport.scrollLeft) state.viewport.scrollLeft = 0;
        });
        if (lastTime && !reduced.matches && !document.hidden) {
          rows.forEach((state) => {
            if (!state.width) return;
            if (state.row.matches(':hover') || now < state.pausedUntil) {
              return;
            }
            state.position = (state.position - Math.min(now - lastTime, 1000) * .05 + state.width) % state.width;
            state.products.forEach((product, index) => {
              const x = (index * state.pitch + state.position + state.pitch) % state.width - state.pitch;
              product.style.transform = `translate3d(${x}px, 0, 0)`;
            });
          });
        }
        lastTime = now;
        if (section.isConnected) requestAnimationFrame(frame);
        else rows.forEach((state) => state.observer.disconnect());
      };
      requestAnimationFrame(frame);
    };
    document.querySelectorAll('[data-sale-edit]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-sale-edit]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
